import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, IconButton, Tooltip, Whisper } from 'rsuite';
import {
  reservationsROItemEditPath,
  reservationsROItemViewPath
} from '../../../../routes/Paths';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import { modifyAccess, fullAccess } from '../../../../helpers/permission';
import IconLink from '../../../IconLink';
import AccessControl from '../../../AccessControl';
import { StringOrNumberType } from '../../../../interfaces';

const { Cell } = Table;

const ActionCell = ({ rowData, dataKey, onDelete, isDeleting, ...props }) => {
  const { id } = rowData;

  return (
    <Cell {...props} className="link-group">
      <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>Edit</Tooltip>}
        >
          <IconLink
            icon="edit2"
            to={pagePathToUrl(reservationsROItemEditPath, { id })}
          />
        </Whisper>
      </AccessControl>

      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip>View</Tooltip>}
      >
        <IconLink
          icon="eye"
          to={pagePathToUrl(reservationsROItemViewPath, { id })}
        />
      </Whisper>

      <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.RO_ITEM)}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>Delete</Tooltip>}
        >
          <IconButton
            style={{ top: '-8px' }}
            appearance="link"
            color="red"
            onClick={() => {
              onDelete(rowData);
            }}
            disabled={isDeleting}
            icon={<Icon icon="trash" />}
          />
        </Whisper>
      </AccessControl>
    </Cell>
  );
};

ActionCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    photo: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
    healthLevel: StringOrNumberType.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string
  }),
  dataKey: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  isDeleting: PropTypes.bool
};

ActionCell.defaultProps = {
  rowData: null,
  onDelete: () => {},
  isDeleting: false
};

export default ActionCell;
